import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Text, TextStyles } from "@cinch-labs/design-system";
import { RelatedJargon } from "@cinch-nx/landing-feature-jargon";
import { Head, JsonLdScript, formatFaqPageSchema } from "@cinch-nx/landing-ui-shared";
import { SVG, Wrapper } from "@cinch-nx/shared-ui";
import { useRouter } from "next/router";
import React, { useEffect, useState } from "react";
import { Speech3D } from "./assets";
import { SearchForm } from "./components/search-form/search-form";
import styles from "./feature-jargon-hub.module.css";
const search = (filteredResults, setResults)=>new Promise((resolve, reject)=>{
        setResults(filteredResults);
        return resolve(filteredResults);
    });
export const JargonHubFeature = ({ stories  })=>{
    var ref, ref1;
    const router = useRouter();
    const query = (ref = router.query) === null || ref === void 0 ? void 0 : (ref1 = ref.q) === null || ref1 === void 0 ? void 0 : ref1.toString();
    const [searchQuery, setSearchQuery] = useState(query || "");
    const [filteredStories, setFilteredStories] = useState([]);
    const [isSearchPending, setSearchPending] = useState(false);
    const searchJargon = (q)=>{
        setSearchQuery(q || "");
        if (!q) {
            return;
        }
        q = q.toLowerCase();
        setSearchPending(true);
        const filtered = stories.filter((item)=>{
            var ref, ref1, ref2, ref3;
            return ((ref = item.content) === null || ref === void 0 ? void 0 : ref.fullTerm.toLowerCase().includes(q)) || ((ref1 = item.content) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.keywords) === null || ref2 === void 0 ? void 0 : ref2.split(",").map((p)=>p.toLowerCase()).includes(q)) || ((ref3 = item.content) === null || ref3 === void 0 ? void 0 : ref3.question.toLowerCase().includes(q));
        });
        return new Promise((resolve)=>{
            search(filtered, setFilteredStories).then(()=>{
                setSearchPending(false);
                resolve();
            }).catch(()=>{
                setSearchPending(false);
                resolve();
            });
        });
    };
    useEffect(()=>{
        if (query) {
            searchJargon(query);
        }
    }, [
        query
    ]);
    const storiesContent = stories.map((story)=>story.content);
    return /*#__PURE__*/ _jsxs("article", {
        className: styles.page,
        children: [
            /*#__PURE__*/ _jsx(JsonLdScript, {
                schema: formatFaqPageSchema(storiesContent),
                tagId: "JargonPage"
            }),
            /*#__PURE__*/ _jsx(Head, {
                fallbackTitle: "Jargon Buster - cinch",
                fallbackDescription: "Want to understand more about how your car works or any obscure industry terms? Our jargon buster is here to make them faff-free."
            }),
            /*#__PURE__*/ _jsxs(Wrapper, {
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles["container"],
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: styles.title,
                                children: /*#__PURE__*/ _jsx(Text, {
                                    element: "h1",
                                    type: TextStyles.mainTitle,
                                    lineHeight: "display",
                                    children: "Jargon Buster"
                                })
                            }),
                            /*#__PURE__*/ _jsx(SearchForm, {
                                initialValues: {
                                    search: searchQuery
                                },
                                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                onSubmit: (values)=>searchJargon(values.search),
                                isPending: isSearchPending
                            }),
                            !isSearchPending && filteredStories.length > 0 && /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: styles.title,
                                        children: /*#__PURE__*/ _jsx(Text, {
                                            element: "h2",
                                            type: TextStyles.vehicleSubTitle,
                                            lineHeight: "display",
                                            children: "Search Results"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        "data-testid": "SearchResults",
                                        children: /*#__PURE__*/ _jsx(RelatedJargon, {
                                            items: filteredStories
                                        })
                                    })
                                ]
                            }),
                            !isSearchPending && filteredStories.length === 0 && searchQuery && /*#__PURE__*/ _jsxs("div", {
                                className: styles.noResultsWrapper,
                                "data-testid": "no-jargon-found",
                                children: [
                                    /*#__PURE__*/ _jsx(Text, {
                                        className: styles.noResultsTitle,
                                        element: "h2",
                                        children: "Sorry, we haven't found any articles that match, try a different word or phrase"
                                    }),
                                    /*#__PURE__*/ _jsx(SVG, {
                                        children: Speech3D,
                                        size: 195,
                                        className: styles.noResultsImage
                                    })
                                ]
                            })
                        ]
                    }),
                    (stories === null || stories === void 0 ? void 0 : stories.length) > 0 && /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: styles.title,
                                "data-testid": "latest-jargon",
                                children: /*#__PURE__*/ _jsx(Text, {
                                    element: "h2",
                                    type: TextStyles.vehicleSubTitle,
                                    lineHeight: "display",
                                    children: "Latest"
                                })
                            }),
                            /*#__PURE__*/ _jsx(RelatedJargon, {
                                items: stories
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
